module.exports = __webpack_public_path__ + "static/media/optimus_logo500.d5908294.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/assets/optimus_logo500.png
// module id = 310
// module chunks = 0